import styled, { css } from 'styled-components'

import { mainColors, XSMedium, XSNormal } from '@avantstay/backoffice-core'

const TILE_SIZE = '120px'
// Big enough for the browser's player controls to fit.
const VIDEO_SIZE = '240px'

const frame = css`
  border: 1px solid ${mainColors.neutralMedium};
  border-radius: 8px;
  overflow: hidden;
`

export const MediaAction = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  opacity: 0;
  transition: opacity 0.15s ease;

  @media (hover: none) {
    opacity: 1;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

export const Media = styled.div`
  position: relative;

  &:hover ${MediaAction}, &:focus-within ${MediaAction} {
    opacity: 1;
  }
`

export const Tile = styled.button`
  ${frame};
  display: block;
  width: ${TILE_SIZE};
  height: ${TILE_SIZE};
  padding: 0;
  background: ${mainColors.neutralLight};
  cursor: zoom-in;

  &:focus-visible {
    outline: 2px solid ${mainColors.accentMedium};
    outline-offset: 2px;
  }
`

export const Thumb = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const Video = styled.video`
  ${frame};
  display: block;
  width: ${VIDEO_SIZE};
  height: ${VIDEO_SIZE};
  object-fit: cover;
  background: ${mainColors.primaryMedium};
`

export const FileChip = styled.button`
  ${frame};
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  padding: 8px 12px;
  background: ${mainColors.white};
  color: ${mainColors.primaryMedium};
  text-align: left;
  cursor: pointer;

  svg {
    flex: none;
    width: 16px;
    height: 16px;
  }

  &:hover {
    border-color: ${mainColors.accentMedium};
  }

  &:focus-visible {
    outline: 2px solid ${mainColors.accentMedium};
    outline-offset: 2px;
  }
`

export const FileAction = styled.span`
  display: grid;
  place-items: center;
  flex: none;
  width: 16px;
  color: ${mainColors.accentMedium};
`

export const FileName = styled(XSMedium)`
  min-width: 0;
  overflow-wrap: anywhere;
`

export const FileSize = styled(XSNormal)`
  flex: none;
`
